<div class="web-app-container">
  <div class="container">
    <div class="bg-borders left-border"></div>
    <div class="bg-borders center-border"></div>
    <div class="bg-borders right-border"></div>
  </div>
  <router-outlet />
</div>
